import  {useState} from 'react'
import {AppRouter} from './app/routers/AppRouter'
import {initSystemSetting, SystemSetting, SystemSettingContext} from "./app/context/SystemContext";
import {ReactKeycloakProvider} from '@react-keycloak/web';
import keycloak from "./app/security/KeyclockConfig";

const eventLogger = (event: unknown, error: unknown) => {
}

const tokenLogger = (tokens: unknown) => {
}

function App() {
    const [systemSetting, setSystemSetting] = useState<SystemSetting>(initSystemSetting);
    return (
        <SystemSettingContext.Provider value={{systemSetting, setSystemSetting}}>
            <ReactKeycloakProvider authClient={keycloak}  initOptions={{
                onLoad: 'check-sso', // Supported values: 'check-sso' , 'login-required'
                checkLoginIframe: true,
                pkceMethod: 'S256'
            }} onEvent={eventLogger}
                                   onTokens={tokenLogger}
            >
                <div className="App">
                    <AppRouter/>
                </div>
            </ReactKeycloakProvider>
        </SystemSettingContext.Provider>
    )
}

export default App
